import { useInsertFavoriteMutation } from '@crew/apis/favorite/favoriteApis'
import { useCallback } from 'react'
import { EntityType } from '@crew/enums/domain'
import { useAppDispatch } from 'states/hooks'
import {
  notifyFavoriteEvent,
  ObjectEventMessage,
} from 'features/app/states/appSlice'
import { Favorite } from '@crew/models/domain'
import { NotifyEventType } from 'enums/app'
import { useInsertProjectForGroupChatMutation } from '@crew/apis/dist/project/projectApis'
import { useShowApiErrors } from 'hooks/useShowApiErrors'

export const useChatStartGroupTabPanel = () => {
  const dispatch = useAppDispatch()
  const [showApiErrors] = useShowApiErrors()

  // グループチャット登録API
  const [
    insertProjectForGroupChatMutation,
    { isLoading: isInsertingGroupChat },
  ] = useInsertProjectForGroupChatMutation()
  // お気に入り登録API
  const [insertFavoriteMutation, { isLoading: isInsertingFavorite }] =
    useInsertFavoriteMutation()

  // グループチャット登録処理
  const insertGroupChat = useCallback(
    async (targetUserIds: string[]) => {
      try {
        const result = await insertProjectForGroupChatMutation({
          targetUserIds,
        }).unwrap()

        return result
      } catch (error) {
        showApiErrors(error)
      }
    },
    [insertProjectForGroupChatMutation, showApiErrors]
  )

  // お気に入り登録処理
  const insertFavorite = useCallback(
    async (entityType: EntityType, entityRecordId: string) => {
      try {
        const response = await insertFavoriteMutation({
          entityType,
          entityRecordId,
        }).unwrap()

        if (!response.favorite) return

        const objectEventMessage: ObjectEventMessage<Favorite> = {
          eventType: NotifyEventType.Inserted,
          id: response.favorite.id,
          object: undefined,
        }

        dispatch(notifyFavoriteEvent(objectEventMessage))
      } catch (error) {
        showApiErrors(error)
      }
    },
    [dispatch, insertFavoriteMutation, showApiErrors]
  )

  return {
    insertGroupChat,
    isInsertingGroupChat,
    insertFavorite,
    isInsertingFavorite,
  }
}
